/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { Verifybody } from '../types';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';

export const verify = (
	data: Verifybody
): Promise<{
	user: any;
}> => {
	return apiClient.patch('/productions/verify', {
		...data,
	});
};

export const useVerify = (page: number, size: number) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: verify,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [
					'productions',
					{ page: page, size: size },
				],
			});
			notifications.show({
				title: 'Success',
				message: t(
					'notifications.verificationStatusSuccessfullyUpdated'
				),
				color: 'success',
				autoClose: 1500,
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: 'Error',
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
